/* eslint-disable */
export const REGEX_EMAIL = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/;
export const REGEX_LETRAS_ESPACIOS = /^[ a-zA-ZñÑáéíóúÁÉÍÓÚÄäËëÏïÖöÜü.,]+$/
export const REGEX_LETRAS_ESPACIOS_NUMS_PUNTOS = /^[ a-zA-Z0-9ñÑáéíóúÁÉÍÓÚÄäËëÏïÖöÜü,.\-&'"\/#()_]+$/
export const REGEX_LETRAS_ESPACIOS_NUMS = /^[ a-zA-Z0-9ñÑáéíóúÁÉÍÓÚÄäËëÏïÖöÜü]+$/
export const REGEX_LETRAS_NOMBRES_CLIENTES = /^[\w\s\-,.&'"/#()áéíóúÁÉÍÓÚñÑüÜ]*$/
export const REGEX_FLOAT = /^([0-9]*[.])?[0-9]*$/
export const REGEX_FLOAT_2DECIMALES = /^([0-9]*)[.]?[0-9]?[0-9]?$/
export const REGEX_FLOAT_NDECIMALES = /^([0-9]*)[.]?[0-9]?[0-9]?[0-9]?[0-9]?[0-9]?[0-9]?[0-9]?[0-9]?$/
export const REGEX_INTEGER = /^[0-9]*$/
export const REGEX_FEX = /^[A-Za-z0-9]+$/
export const REGEX_ALFANUM = /^[0-9A-Za-zñÑáéíóúÁÉÍÓÚÄäËëÏïÖöÜü]*$/
export const REGEX_LETTERS = /^[\x20-\x7FñÑáéíóúÁÉÍÓÚÄäËëÏïÖöÜü]*$/
export const REGEX_SOLO_LETRAS_SPANISH = /^[a-zA-ZñÑáéíóúÁÉÍÓÚÄäËëÏïÖöÜü]+$/
export const REGEX_USER_NAME = /^[0-9A-Za-zñÑáéíóúÁÉÍÓÚÄäËëÏïÖöÜü0-9_\.]+$/
export const REGEX_USER_NUM_DOCUMENTO = /^(?!.*--)[A-Za-z0-9][A-Za-z0-9-]*$/
export const REGEX_ALFANUM_ESPACIOS = /^[ 0-9A-Za-zñÑáéíóúÁÉÍÓÚÄäËëÏïÖöÜü]*$/
export const REGEX_ALFANUM_CON_ESPECIALES = /^[ 0-9A-Za-zñÑáéíóúÁÉÍÓÚÄäËëÏïÖöÜü(),.#/()-]*$/

export const REGEX_PRODUCTO_TEXTO = /^[ a-zA-Z0-9ñÑáéíóúÁÉÍÓÚ.,-]+$/
export const REGEX_CODIGO_PRODUCTO = /^[A-Za-z0-9_-]+$/



export const REGEX_CODIGO_GENERACION = /^[0-9A-F]{8}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{12}$/
export const REGEX_FECHA_EMISION = /\d{4}-\d{2}-\d{2}/; // Ej 2024-02-22
export const REGEX_FECHA_EMISION_DDMMYYYY = /\d{2}\/\d{2}\/\d{4}/; // Ej 22/02/2024

// Minimo minuscula, mayuscula, numero y simbolo, minimo 5 
export const REGEX_PASSWORD = /^(?=.*\d)(?=.*[\u0021-\u002b\u003c-\u0040])(?=.*[A-Z])(?=.*[a-z])\S{5,}$/
export const REGEX_NIT = /^([0-9]{14}|[0-9]{9})$/
export const REGEX_NIT2 = /^([0-9]{14}|[0-9]{9})$/
export const REGEX_NIT_GUION = /^(?:[0-9]-?){8}[0-9]$|^(?:[0-9]-?){13}[0-9]$/;
export const REGEX_INT_GUION = /^[0-9-]*$/
export const REGEX_DOC_GUION = /^[0-9A-Za-z-]*$/

export const REGEX_NRC = /^[0-9]{2,}$/
export const REGEX_CODE_ACTIVIDAD = /^[0-9]{2,6}$/

export const REGEX_TELEFONO = /^(\+\d{1,3}( )?)?((\(\d{1,3}\))|\d{1,3})[- .]?\d{3,4}[- .]?\d{4}$/

export const REGEX_SERIE = /^[a-zA-Z0-9]+([-][a-zA-Z0-9]+)*$/

// TIPO DE DOCUMENTOS
export const REGEX_PASAPORTE = /^[A-Z0-9\\-]+$/
export const REGEX_DUI = /^[0-9\s]{9}$/g
export const REGEX_DUI2 = /^[0-9\s]{9}$/
export const REGEX_CARNET_REDIDENCIAL = /^[0-9A-Z]{14}$/
export const REGEX_OTRO = /^[A-Z0-9\\-]+$/
export const REGEX_HTML = /<\/?[^>]+(>|$)/g
export const REGEX_OPERACIONES_MSG = /\[.*?\]\s*/
export const REGEX_DECIMALES_3DIGITOS = /\d(?=(\d{3})+\.)/g

export const REGEX_REPLACE_SLASH = /\//g

export const REGEX_SERIE_DOCUMENTO_V1 = /^[A-Z0-9]{8}$/
export const REGEX_SERIE_DOCUMENTO_V2 = /^(M|B|S|P)[0-9]{3}P[0-9]{3}$/
export const REGEX_CODIGO_ESTABLECIMIENTO_V2 = /^(M|B|S|P)[0-9]{3}$/
export const REGEX_PUNTO_VENTA_V2 = /^P[0-9]{3}$/
export const REGEX_SERIE_DOCUMENTO_TECLEO = /^[A-Za-z0-9]*$/
